import { useAtomValue } from 'jotai';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import ErrorIndicator from '../components/ErrorIndicator';
import LoadingIndicator from '../components/LoadingIndicator';
import ActualityMainLayoutView from './layout/ActualityMainLayoutView';
import ActualitySettingsContentView from './layout/ActualitySettingsContentView';
import { actualitySelectedDocument } from './store/actuality.state';
import { actualitySelectedMenuIdAtom } from './store/actuality.ui.state';

/**
 * Container for Actuality main(central panel) content
 */

const ActualityMainContentView: React.FC = () => {
  const { t } = useTranslation('feed');
  const actuality = useRecoilValue(actualitySelectedDocument);

  const selectedMenuId = useAtomValue(
    actualitySelectedMenuIdAtom(actuality.id),
  );

  function getContent() {
    switch (selectedMenuId) {
      case 'feed-menu-setup':
        return <ActualitySettingsContentView />;

      default:
        return <ActualityMainLayoutView />;
    }
  }

  return (
    <ErrorBoundary
      fallbackRender={({ error, resetErrorBoundary }) => (
        <ErrorIndicator
          selfCenter
          message={error.message}
          hasReloadButton
          exception={error}
        />
      )}
    >
      <Suspense
        fallback={
          <LoadingIndicator
            // className={cn(
            //   'bg-map-area-striped',
            //   'border-app-background border-8',
            // )}
            // selfCenter
            message={t`Loading...`}
          />
        }
      >
        {getContent()}
      </Suspense>
    </ErrorBoundary>
  );
};

export default ActualityMainContentView;
